export default __webpack_public_path__ + "static/media/LightBlue0002.0993f8f5.png";